import { render, staticRenderFns } from "./CoderView.vue?vue&type=template&id=fdac316a&scoped=true&"
import script from "./CoderView.vue?vue&type=script&lang=js&"
export * from "./CoderView.vue?vue&type=script&lang=js&"
import style0 from "./CoderView.vue?vue&type=style&index=0&id=fdac316a&prod&lang=scss&scoped=true&"
import style1 from "./CoderView.vue?vue&type=style&index=1&id=fdac316a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdac316a",
  null
  
)

export default component.exports